import React, { useEffect } from "react";

const ExternalLinkFix = () => {
  useEffect(() => {
    const links = document.querySelectorAll("a[href^='http']:not([href*='" + window.location.host + "'])");

    links.forEach(link => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }, []);

  return null;
};

export default ExternalLinkFix;
